import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Row,
  Col,
  Button,
  UncontrolledTooltip,
  Nav,
  NavItem,
} from 'reactstrap'
import { StaticQuery, graphql, Link } from 'gatsby'
import LogoFooter from '../../assets/img/logo_footer.svg'
import LogoAlink from '../../assets/img/alink-logo.png'
import menu from '../../menu'
// PDFs - Certifications
import pdfCertificatoIso from '../../assets/pdf/certificato-iso-9001-2015-materia3.pdf'
import pdfPoliticaQualita from '../../assets/pdf/politica-qualita-materia3.pdf'
import pdfCodiceEtico from '../../assets/pdf/codice-etico-materia3.pdf'
import pdfAlbo2bis from '../../assets/pdf/anga-iscrizione-cat-2bis-materia3.pdf'
import pdfAlbo8E from '../../assets/pdf/anga-iscrizione-cat-8E-materia3.pdf'
import pdfAlbo9E from '../../assets/pdf/anga-iscrizione-cat-9E-materia3.pdf'

const SocialLink = ({ url, kind }) => {
  if (!url) return ''
  return (
    <>
      <Button
        className="btn-neutral text-white"
        color="default"
        size="sm"
        href={url}
        id={kind}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className={`icon-${kind}`} />
      </Button>
      <UncontrolledTooltip delay={0} target={kind}>
        Follow us
      </UncontrolledTooltip>
    </>
  )
}

SocialLink.propTypes = {
  url: PropTypes.string,
  kind: PropTypes.string.isRequired,
}

SocialLink.defaultProps = {
  url: undefined,
}

const Footer = () => (
  <StaticQuery
    query={graphql`
      query companyFooterQuery {
        datoCmsCompany {
          email
          city
          address
          address2
          name
          phone
          zip
          vatNumber
          twitter
          facebook
          instagram
          linkedin
        }
      }
    `}
    render={data => {
      const company = data.datoCmsCompany
      return (
        <footer id="footer" className="section">
          <Container>
            <Row>
              <Col md="3">
                <img alt="Materia3 logo" src={LogoFooter} className="mb-2" />
                <p className="text-white">
                  <small className="block">
                    <span className="d-block">
                      {`© ${new Date().getFullYear()} ${company.name}`}
                    </span>
                    <span className="text-muted d-block">
                      Sede legale ed operativa:
                    </span>
                    <span className="d-block">{`${company.address} ${company.zip} ${company.city}`}</span>
                    {company.address2 ? (
                      <>
                        <span className="text-muted d-block">
                          Sede operativa:
                        </span>
                        <span className="d-block">{company.address2}</span>
                      </>
                    ) : null}
                    <span className="d-block">
                      {`Tel: ${company.phone} · email: `}
                      <a
                        href={`mailto:${company.email}`}
                        className="text-danger"
                      >
                        {company.email}
                      </a>
                    </span>
                    <span className="d-block">
                      {`P.iva: ${company.vatNumber} · `}
                      <Link to="/privacy" className="text-danger">
                        Privacy
                      </Link>
                    </span>
                  </small>
                </p>
                <div className="btn-wrapper socials mb-3">
                  {['twitter', 'facebook', 'instagram', 'linkedin'].map(
                    kind => (
                      <SocialLink key={kind} url={company[kind]} kind={kind} />
                    )
                  )}
                </div>
              </Col>
              <Col md="3" className="d-none d-md-block">
                <h4 className="text-muted">Azienda</h4>
                <Nav vertical>
                  {menu.map(({ name, link }) => {
                    if (link === '/') return <></>
                    return (
                      <NavItem>
                        <Link to={link} className="text-white">
                          {name}
                        </Link>
                      </NavItem>
                    )
                  })}
                </Nav>
              </Col>
              <Col md="4" className="mb-4 no-caret">
                <h4 className="mb-1 text-muted">Certificazioni</h4>
                <Nav vertical>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfCertificatoIso}
                    >
                      Sistema di Gestione Qualità – UNI EN ISO 9001:2015
                    </a>
                  </NavItem>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfPoliticaQualita}
                    >
                      Politica Qualità
                    </a>
                  </NavItem>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfCodiceEtico}
                    >
                      Codice Etico
                    </a>
                  </NavItem>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfAlbo2bis}
                    >
                      Albo Nazionale Gestori Ambientali Cat. 2 bis
                    </a>
                  </NavItem>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfAlbo8E}
                    >
                      Albo Nazionale Gestori Ambientali Cat. 8 classe E
                    </a>
                  </NavItem>
                  <NavItem>
                    <a
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={pdfAlbo9E}
                    >
                      Albo Nazionale Gestori Ambientali Cat. 9 classe E
                    </a>
                  </NavItem>
                </Nav>
              </Col>
              <Col md="2">
                <h4 className="mb-1 text-muted">Rete di imprese</h4>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ambientalink.it"
                >
                  <img
                    alt="a-link"
                    src={LogoAlink}
                    className="mt-1"
                    width="150"
                  />
                </a>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <div className="credits border-top text-center mt-2 pt-3">
                  <a href="https://www.extendi.it" className="d-block">
                    <p>Made by Extendi</p>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      )
    }}
  />
)

export default Footer
